import React from "react";

function Uploadbutton() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 19.9998C3.95 19.9998 3.47933 19.8042 3.088 19.4128C2.69667 19.0215 2.50067 18.5505 2.5 17.9998V15.9998C2.5 15.7165 2.596 15.4792 2.788 15.2878C2.98 15.0965 3.21733 15.0005 3.5 14.9998C3.78267 14.9992 4.02033 15.0952 4.213 15.2878C4.40567 15.4805 4.50133 15.7178 4.5 15.9998V17.9998H16.5V15.9998C16.5 15.7165 16.596 15.4792 16.788 15.2878C16.98 15.0965 17.2173 15.0005 17.5 14.9998C17.7827 14.9992 18.0203 15.0952 18.213 15.2878C18.4057 15.4805 18.5013 15.7178 18.5 15.9998V17.9998C18.5 18.5498 18.3043 19.0208 17.913 19.4128C17.5217 19.8048 17.0507 20.0005 16.5 19.9998H4.5ZM9.5 7.84982L7.625 9.72482C7.425 9.92482 7.18767 10.0208 6.913 10.0128C6.63833 10.0048 6.40067 9.90049 6.2 9.69982C6.01667 9.49982 5.92067 9.26649 5.912 8.99982C5.90333 8.73315 5.99933 8.49982 6.2 8.29982L9.8 4.69982C9.9 4.59982 10.0083 4.52915 10.125 4.48782C10.2417 4.44649 10.3667 4.42549 10.5 4.42482C10.6333 4.42415 10.7583 4.44515 10.875 4.48782C10.9917 4.53049 11.1 4.60115 11.2 4.69982L14.8 8.29982C15 8.49982 15.096 8.73315 15.088 8.99982C15.08 9.26649 14.984 9.49982 14.8 9.69982C14.6 9.89982 14.3627 10.0042 14.088 10.0128C13.8133 10.0215 13.5757 9.92549 13.375 9.72482L11.5 7.84982V14.9998C11.5 15.2832 11.404 15.5208 11.212 15.7128C11.02 15.9048 10.7827 16.0005 10.5 15.9998C10.2173 15.9992 9.98 15.9032 9.788 15.7118C9.596 15.5205 9.5 15.2832 9.5 14.9998V7.84982Z"
        fill="#667085"
      />
    </svg>
  );
}

export default Uploadbutton;
